import Helmet from 'react-helmet'
import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {canonicalPath, landingPages, pagePaths} from './siteContent'
export {pagePaths} from './siteContent'

export default function Seo() {
    const path = canonicalPath(useLocation().pathname)
    useEffect(() => {
        try { window.fleekaAnalytics36?.page() } catch (_) { /* Non-blocking analytics. */ }
    }, [path])
    const page = landingPages[path]
    const known = pagePaths.includes(path)
    const policy = path === '/policy/'
    const title = page?.title || (policy ? 'Пользовательское соглашение — Флика' : 'Страница не найдена — Флика')
    const description = page?.description || (policy ? 'Пользовательское соглашение сервиса междугороднего такси Флика.' : 'Страница не найдена на сайте Флика.')
    const url = 'https://fleeka.ru' + path
    const org = {'@type': 'Organization', '@id': 'https://fleeka.ru/#organization', name: 'Флика', alternateName: 'FLEEKA', url: 'https://fleeka.ru/', telephone: '+79507007071', logo: 'https://fleeka.ru/logo/fleeka-logo-new.png', sameAs: ['https://t.me/taxiFLEEKA']}
    const graph = [org,
        {'@type': 'WebSite', '@id': 'https://fleeka.ru/#website', url: 'https://fleeka.ru/', name: 'Флика', alternateName: 'FLEEKA', inLanguage: 'ru', publisher: {'@id': org['@id']}},
        {'@type': 'WebPage', '@id': url + '#webpage', url, name: title, description, inLanguage: 'ru', isPartOf: {'@id': 'https://fleeka.ru/#website'}, ...(page ? {mainEntity: {'@id': url + '#service'}} : {})}
    ]
    if (page) graph.push({'@type': 'TaxiService', '@id': url + '#service', name: page.h1, description: page.intro, serviceType: 'Междугородние поездки', url, provider: {'@id': org['@id']}})
    if (page && path !== '/') graph.push({'@type': 'BreadcrumbList', '@id': url + '#breadcrumb', itemListElement: [
        {'@type': 'ListItem', position: 1, name: 'Главная', item: 'https://fleeka.ru/'},
        {'@type': 'ListItem', position: 2, name: page?.label || 'Пользовательское соглашение', item: url}
    ]})
    return <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content={known ? 'index,follow' : 'noindex,follow'} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:locale" content="ru_RU" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="https://fleeka.ru/og/image.png" />
        {known && <meta property="og:url" content={url} />}
        {known && <link rel="canonical" href={url} />}
        {known && <script type="application/ld+json" id="fleeka-structured-data">{JSON.stringify({'@context': 'https://schema.org', '@graph': graph}).replace(/</g, '\\u003c')}</script>}
    </Helmet>
}
